export const areEmailAddressesEqual = (emailA, emailB) => Boolean(emailA && emailB) && emailA.toLowerCase() === emailB.toLowerCase();